import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { MainButton } from '@/components/ui/Button/Button';

import { useOpenSpecContract } from './open-spec-contract.hook';

interface OpenSpecContractButtonProps {
  kind: SpecContractType | PaidSpecContractType;
}

const OpenSpecContractButton: FC<OpenSpecContractButtonProps> = ({ kind }) => {
  const btnProps = useOpenSpecContract(kind);
  const { t } = useTranslation();

  return (
    <MainButton className="flex-1 !w-auto" text={t('Open')} {...btnProps} />
  );
};

export { OpenSpecContractButton };
